import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCard"><Path d="M12 7.25C12.8284 7.25 13.5 7.92157 13.5 8.75C13.5 9.57843 12.8284 10.25 12 10.25C11.1716 10.25 10.5 9.57843 10.5 8.75C10.5 7.92157 11.1716 7.25 12 7.25Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H4V2H20V22ZM8 16.5V18H16V16.5H8ZM8 15H16V13.5H8V15ZM12 5.75C10.3431 5.75 9 7.09315 9 8.75C9 10.4069 10.3431 11.75 12 11.75C13.6569 11.75 15 10.4069 15 8.75C15 7.09315 13.6569 5.75 12 5.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCard;
